module.exports = __webpack_public_path__ + "static/background-404-3eafd19eeb08bc312aebe7ec72e3db55.jpg";